import { http } from './http';

export interface ApiDrawerWithCount {
  id: number;
  drawerName: string;
  drawerOrder?: number | null;
  documentCount: number;
}

function normalize(d: any): ApiDrawerWithCount {
  const rawOrder = d?.drawerOrder ?? d?.DrawerOrder;
  return {
    id: Number(d?.id ?? d?.Id),
    drawerName: String(d?.drawerName ?? d?.DrawerName ?? ''),
    drawerOrder: rawOrder === undefined || rawOrder === null ? rawOrder : Number(rawOrder),
    documentCount: Number(d?.documentCount ?? d?.DocumentCount ?? 0)
  };
}

export async function getDrawersWithCounts(): Promise<ApiDrawerWithCount[]> {
  const data = await http<any[]>('/api/drawer/withcounts');
  return Array.isArray(data) ? data.map(normalize) : [];
}
